/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Barra dei passi del wizard: i passi completati sono cliccabili per tornare indietro. */
export const SetupStepper = ({ steps, step, onStepChange }) => (
  <ol className="grid grid-cols-5 gap-2" data-testid="setup-stepper">
    {steps.map((s, i) => {
      const Icon = s.icon; const active = i === step; const done = i < step;
      return (
        <li key={s.id}>
          <button type="button" onClick={() => done && onStepChange(i)} className={cn('w-full rounded-xl border p-2.5 text-left transition-colors', active ? 'border-primary bg-primary/5' : done ? 'border-success/40 bg-success/5' : 'border-border/70 bg-card')} data-testid={`setup-step-${s.id}`}>
            <div className="flex items-center gap-2">
              <span className={cn('h-7 w-7 rounded-lg flex items-center justify-center text-xs font-bold', active ? 'bg-primary text-primary-foreground' : done ? 'bg-success text-success-foreground' : 'bg-muted text-muted-foreground')}>{done ? <Check className="h-3.5 w-3.5" /> : i + 1}</span>
              <span className="text-xs font-semibold truncate hidden sm:flex items-center gap-1"><Icon className="h-3.5 w-3.5" /> {s.label}</span>
            </div>
          </button>
        </li>
      );
    })}
  </ol>
);
